import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { EASE_IN_OUT } from '../../utils/motion';
type PlaygroundVisualProps = {
  visual: 'cards' | 'motion' | 'prompt' | 'coffee';
};
export function PlaygroundVisual({
  visual
}: PlaygroundVisualProps) {
  const reduce = useReducedMotion();
  if (visual === 'coffee') {
    return <div aria-hidden className="absolute inset-0 bg-[#DAEFE8] shadow-[inset_0_0_0_8px_#C9E5DB]" data-id="element-317" data-mp="2kp1hczqzo5ol">
        {/* Album */}
        <div className="absolute left-[12%] top-[22%] h-[52%] w-[42%] -rotate-[4deg] rounded-xl bg-[#1E4B48] p-[2.5%] shadow-md" data-id="element-318" data-mp="1s15efdatthjd">
          <div className="grid h-full grid-cols-2 gap-px overflow-hidden rounded-md bg-[#E3E6E3]" data-id="element-319" data-mp="1wzyr53iah4ih">
            <div className="flex flex-col gap-[10%] bg-[#FFFFFF] p-[10%]" data-id="element-320" data-mp="21r8f7zo6vzs9">
              <span className="h-[38%] -rotate-3 rounded-sm bg-[#F9E4DE]" data-id="element-321" data-mp="14bukaenzele7" />
              <span className="ml-auto h-[38%] w-[80%] rotate-2 rounded-sm bg-[#FCEFA8]" data-id="element-322" data-mp="149gp85tax96n" />
            </div>
            <div className="flex flex-col gap-[10%] bg-[#FFFFFF] p-[10%]" data-id="element-323" data-mp="198bbjhqh9fvi">
              <span className="h-[38%] w-[85%] rotate-2 rounded-sm bg-[#D9CCF7]" data-id="element-324" data-mp="wgm8zi3thhfd" />
              <span className="ml-auto h-[38%] -rotate-2 rounded-sm bg-[#E4EDEB]" data-id="element-325" data-mp="rjm6fh66ewt0" />
            </div>
          </div>
        </div>
        {/* Books */}
        <span className="absolute left-[60%] top-[26%] h-[48%] w-[22%] rotate-[8deg] rounded-[4px_8px_8px_4px] bg-[#1E4B48] shadow-md" data-id="element-326" data-mp="iq927j2nw8rm" />
        <span className="absolute left-[64%] top-[34%] h-[48%] w-[22%] -rotate-[6deg] rounded-[4px_8px_8px_4px] bg-[#FCEFA8] shadow-md" data-id="element-327" data-mp="drxvhh7nyedm" />
        {/* Cup */}
        <span className="absolute right-[6%] top-[8%] grid h-[22%] w-auto aspect-square place-items-center rounded-full bg-[#FFFFFF] shadow-sm" data-id="element-328" data-mp="3sqd2fm2ntjn">
          <span className="h-[62%] w-[62%] rounded-full bg-[#B56A2E] shadow-[0_0_0_3px_#F2A99C]" data-id="element-329" data-mp="3vxuagbrvxw0e" />
        </span>
      </div>;
  }
  if (visual === 'cards') {
    return <div aria-hidden className="absolute inset-0 grid place-items-center bg-surface" data-id="element-330" data-mp="1u4wcy2n5yf94">
        <div className="relative h-[58%] w-[34%]" data-id="element-331" data-mp="3nnd79agvwt6t">
          <div className="absolute inset-0 -rotate-[14deg] -translate-x-[40%] rounded-lg bg-ink shadow-md" data-id="element-332" data-mp="3nmk8ows2x9zr" />
          <div className="absolute inset-0 rotate-0 rounded-lg bg-coral shadow-md" data-id="element-333" data-mp="3sgogtjd2zo2f" />
          <div className="absolute inset-0 rotate-[14deg] translate-x-[40%] rounded-lg bg-coral-soft shadow-md" data-id="element-334" data-mp="3ep1jrhbbebil" />
        </div>
      </div>;
  }
  if (visual === 'motion') {
    return <div aria-hidden className="absolute inset-0 grid place-items-center bg-night" data-id="element-335" data-mp="a9i5q55kh8bn">
        <div className="flex gap-2.5" data-id="element-336" data-mp="f6s62fuhv4e9">
          {['bg-coral', 'bg-white', 'bg-ink-soft'].map((c, i) => <motion.span key={c} className={`h-3 w-3 rounded-full ${c}`} animate={reduce ? undefined : {
          y: [0, -8, 0]
        }} transition={{
          duration: 0.9,
          ease: EASE_IN_OUT,
          repeat: Infinity,
          repeatDelay: 0.4,
          delay: i * 0.12
        }} data-id="element-337" data-mp="17sfv3rc2hfz" data-mpi={i} />)}
        </div>
      </div>;
  }
  return <div aria-hidden className="absolute inset-0 grid place-items-center bg-coral-soft" data-id="element-338" data-mp="2igbycglulh70">
      <div className="flex items-center gap-2 rounded-full bg-white px-4 py-2 text-xs font-medium text-rust shadow-sm" data-id="element-339" data-mp="2ef0gix97u09d">
        prompt <span className="text-fg-faint" data-id="element-340" data-mp="2sf1i6exb1bpw">→</span> prototype
      </div>
    </div>;
}